import React from 'react';

import cn from 'classnames';

import { FullStarSVG, StarSVG } from '@components/svgs';

export const IdealAnswerStar: React.FC<
  React.PropsWithChildren<{ className?: string; ideal: boolean; onClick: () => void }>
> = ({ ideal, onClick, className }) => (
  <span className={cn('absolute', className)} onClick={() => onClick()}>
    {ideal ? <FullStarSVG width='16' height='16' /> : <StarSVG width='16' height='16' className='text-gray-400' />}
  </span>
);
